import { createSlice } from '@reduxjs/toolkit'
import { addManageAction, deleteManageByIdAction, getMangeDataAction, getMangeDataByIdAction, updateManageByIdAction, updatePasswordByIdAction, finishJobByIdAction, markShipmentDepartedAction } from '../actions/mangeActionV2';


const initialState = {


    
    finishJob: {
        loading: 'idle',
        hasError: false,
        errorMessage: "",
        object: {}
    },
    markShipmentDeparted: {
        loading: 'idle',
        hasError: false,
        errorMessage: "",
        object: {}
    },
   
    addManage: {
        loading: 'idle',
        hasError: false,
        errorMessage: "",
        object: {},

    },
    updateManage: {
        loading: 'idle',
        hasError: false,
        errorMessage: "",
        object: {}

    },
    deleteManage: {
        loading: 'idle',
        hasError: false,
        errorMessage: "",
        deleted: false,
        object: {}
    },
    getManage: {
        loading: 'idle',
        hasError: false,
        errorMessage: "",
        object: {}

    },
    objectById: {
        content: {},
        loading: 'idle',
        hasError: false,
        errorMessage: "",
    },
    updatePassword: {
        loading: 'idle',
        hasError: false,
        errorMessage: "",
        object: {}
    }
};


export const manageSliceV2 = createSlice({
    name: 'manageV2',
    initialState,
    reducers: {
        resetState: (state) => {
            return { ...initialState};
        },
        resetAdd: (state) => {
             return { ...initialState, addManage: initialState.addManage }
        },
        resetUpdated: (state) => {
            return { ...initialState, updateManage: initialState.updateManage }
        },
        resetDelete: (state) => {
            return { ...initialState, deleteManage: initialState.deleteManage }
        },
        resetGetManage: (state) => {
            return { ...initialState, getManage: initialState.getManage }
        },

        resetObjectById: (state) => {
            return { ...initialState, objectById: initialState.objectById }
        },


    },
    extraReducers: (builder) => {
        builder

            .addCase(getMangeDataAction.pending, (state, action) => {
                state.getManage.loading = 'pending';
                state.getManage.hasError = false;
                state.getManage.errorMessage = "";
                state.getManage.object = {};
            })
            .addCase(getMangeDataAction.fulfilled, (state, action) => {

                state.getManage.loading = 'succeeded';
                state.getManage.object = action.payload
                state.getManage.errorMessage = "";
            })
            .addCase(getMangeDataAction.rejected, (state, action) => {
                state.getManage.loading = 'failed';
                state.getManage.hasError = true;
                state.getManage.errorMessage = action.payload;
            })

            ///
            .addCase(updateManageByIdAction.pending, (state, action) => {
                state.updateManage.loading = 'pending';
                state.updateManage.hasError = false;
                state.updateManage.errorMessage = "";
            })
            .addCase(updateManageByIdAction.fulfilled, (state, action) => {
                state.updateManage.loading = 'succeeded';
                state.updateManage.object = action.payload
                state.updateManage.hasError = false;
                state.updateManage.errorMessage = "";
            })
            .addCase(updateManageByIdAction.rejected, (state, action) => {
                state.updateManage.loading = 'failed';
                state.updateManage.hasError = true;
                state.updateManage.errorMessage = action.payload;

            })
            //

            .addCase(getMangeDataByIdAction.pending, (state, action) => {
                state.objectById.loading = 'pending';
                state.objectById.hasError = false;
                state.objectById.errorMessage = "";
            })
            .addCase(getMangeDataByIdAction.fulfilled, (state, action) => {
                state.objectById.loading = 'succeeded';
                state.objectById.content = action.payload
                state.objectById.hasError = false;
                state.objectById.errorMessage = "";
            })
            .addCase(getMangeDataByIdAction.rejected, (state, action) => {
                state.objectById.loading = 'failed';
                state.objectById.hasError = true;
                state.objectById.errorMessage = action.payload;
            })
            //
            .addCase(deleteManageByIdAction.pending, (state, action) => {
                state.deleteManage.loading = 'pending';
                state.deleteManage.hasError = false;
                state.deleteManage.errorMessage = "";
            })
            .addCase(deleteManageByIdAction.fulfilled, (state, action) => {
                state.deleteManage.loading = 'succeeded';
                state.deleteManage.deleted = true;
                state.deleteManage.object = action.payload;
                state.deleteManage.hasError = false;
                state.deleteManage.errorMessage = "";
            })
            .addCase(deleteManageByIdAction.rejected, (state, action) => {
                state.deleteManage.loading = 'failed';
                state.deleteManage.deleted = false;
                state.deleteManage.hasError = true;
                state.deleteManage.errorMessage = action.payload;

            })
            //
            .addCase(addManageAction.pending, (state, action) => {
                state.addManage.loading = 'pending';
                state.addManage.added = false;
                state.addManage.hasError = false;
                state.addManage.errorMessage = "";
            })
            .addCase(addManageAction.fulfilled, (state, action) => {
                state.addManage.loading = 'succeeded';
                state.addManage.added = true;
                state.addManage.hasError = false;
                state.errorMessage = "";
            })
            .addCase(addManageAction.rejected, (state, action) => {
                state.addManage.loading = 'failed';
                state.addManage.added = false;
                state.addManage.hasError = true;
                state.addManage.errorMessage = action.payload;

            })
            //updatePasswordById
            .addCase(updatePasswordByIdAction.pending, (state, action) => {
                state.updatePassword.loading = 'pending';
                state.updatePassword.hasError = false;
                state.updatePassword.errorMessage = "";
            })
            .addCase(updatePasswordByIdAction.fulfilled, (state, action) => {
                state.updatePassword.loading = 'succeeded';
                state.updatePassword.hasError = false;
                state.updatePassword.errorMessage = "";
            })
            .addCase(updatePasswordByIdAction.rejected, (state, action) => {
                state.updatePassword.loading = 'failed';
                state.updatePassword.hasError = true;
                state.errorMessage = action.payload;

            })

            // finishJobByIdAction
            .addCase(finishJobByIdAction.pending, (state) => {
                state.finishJob.loading = 'pending';
                state.finishJob.hasError = false;
                state.finishJob.errorMessage = "";
            })
            .addCase(finishJobByIdAction.fulfilled, (state, action) => {
                state.finishJob.loading = 'succeeded';
                state.finishJob.object = action.payload;
                state.finishJob.hasError = false;
                state.finishJob.errorMessage = "";
            })
            .addCase(finishJobByIdAction.rejected, (state, action) => {
                state.finishJob.loading = 'failed';
                state.finishJob.hasError = true;
                state.finishJob.errorMessage = action.payload;
            })

            // markShipmentDepartedAction
            .addCase(markShipmentDepartedAction.pending, (state) => {
                state.markShipmentDeparted.loading = 'pending';
                state.markShipmentDeparted.hasError = false;
                state.markShipmentDeparted.errorMessage = "";
            })
            .addCase(markShipmentDepartedAction.fulfilled, (state, action) => {
                state.markShipmentDeparted.loading = 'succeeded';
                state.markShipmentDeparted.object = action.payload;
                state.markShipmentDeparted.hasError = false;
                state.markShipmentDeparted.errorMessage = "";
            })
            .addCase(markShipmentDepartedAction.rejected, (state, action) => {
                state.markShipmentDeparted.loading = 'failed';
                state.markShipmentDeparted.hasError = true;
                state.markShipmentDeparted.errorMessage = action.payload;
            })




           
    }
})
export const {resetState,resetAdd,resetDelete,resetGetManage,resetObjectById,resetUpdated} = manageSliceV2.actions;

export default manageSliceV2.reducer